// extracted by mini-css-extract-plugin
export var arrows = "_98-6";
export var decrementer = "_98-a";
export var disabled = "_98-4";
export var error = "_98-1";
export var hiddenText = "_98-b";
export var incrementer = "_98-9";
export var input = "_98-8";
export var inputWrapper = "_98-0";
export var leadingIcon = "_98-c";
export var readonly = "_98-3";
export var regular = "_98-7";
export var small = "_98-5";
export var warning = "_98-2";